/* ==========================================================================
   REAL STREET COMEDY — product.js
   Gallery + variant picker. Enhances server-rendered markup; the page is a
   fully working product form before this file executes.
   ========================================================================== */
(function () {
  'use strict';

  var Theme = (window.RSC = window.RSC || {});

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn, opts) { if (el && el.addEventListener) el.addEventListener(evt, fn, opts); }

  /* ------------------------------------------------------------------------
     Gallery
     ------------------------------------------------------------------------ */
  function initGallery(scope) {
    $$('[data-gallery]', scope).forEach(function (gallery) {
      var slides = $$('[data-gallery-slide]', gallery);
      var thumbs = $$('[data-gallery-thumb]', gallery);
      if (slides.length < 2 && thumbs.length < 2) return;

      function show(id) {
        slides.forEach(function (slide) {
          slide.classList.toggle('is-active', slide.getAttribute('data-media-id') === id);
        });
        thumbs.forEach(function (thumb) {
          var current = thumb.getAttribute('data-media-id') === id;
          thumb.setAttribute('aria-current', current ? 'true' : 'false');
        });
      }

      thumbs.forEach(function (thumb) {
        on(thumb, 'click', function (e) {
          e.preventDefault();
          show(thumb.getAttribute('data-media-id'));
        });
      });

      gallery.__show = show;
    });
  }

  /* ------------------------------------------------------------------------
     Variant picker
     ------------------------------------------------------------------------ */
  function initVariantPicker(scope) {
    $$('[data-variant-picker]', scope).forEach(function (picker) {
      var dataEl = $('[data-variant-json]', picker);
      if (!dataEl) return;

      var variants;
      try {
        variants = JSON.parse(dataEl.textContent);
      } catch (e) {
        return;
      }
      if (!Array.isArray(variants) || !variants.length) return;

      var sectionId = picker.getAttribute('data-section');
      var form = document.querySelector('[data-product-form][data-section="' + sectionId + '"]');
      var idInput = form ? form.querySelector('[data-variant-id]') : null;
      var addButton = form ? form.querySelector('[data-add-button]') : null;
      var addLabel = addButton ? addButton.querySelector('[data-add-label]') : null;
      var priceHost = document.querySelector('[data-price-host][data-section="' + sectionId + '"]');
      var gallery = document.querySelector('[data-gallery][data-section="' + sectionId + '"]');
      var skuHost = document.querySelector('[data-sku][data-section="' + sectionId + '"]');
      var updateUrl = picker.getAttribute('data-update-url') === 'true';

      function selectedOptions() {
        return $$('fieldset[data-option-index]', picker).map(function (fieldset) {
          var checked = fieldset.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }

      function findVariant(options) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = true;
          for (var j = 0; j < options.length; j++) {
            if (options[j] === null) { match = false; break; }
            if (v.options[j] !== options[j]) { match = false; break; }
          }
          if (match) return v;
        }
        return null;
      }

      // Grey out option values that cannot combine with the current selection
      function markAvailability(options) {
        $$('fieldset[data-option-index]', picker).forEach(function (fieldset, index) {
          $$('input', fieldset).forEach(function (input) {
            var probe = options.slice();
            probe[index] = input.value;
            var candidates = variants.filter(function (v) {
              for (var j = 0; j < probe.length; j++) {
                if (j === index) { if (v.options[j] !== probe[j]) return false; continue; }
                if (probe[j] !== null && v.options[j] !== probe[j]) return false;
              }
              return true;
            });
            var available = candidates.some(function (v) { return v.available; });
            var label = fieldset.querySelector('label[for="' + input.id + '"]');
            if (label) label.classList.toggle('is-unavailable', !available && candidates.length > 0);
          });
        });
      }

      function setButtonState(variant) {
        if (!addButton) return;
        var soldOut = !variant || !variant.available;
        addButton.disabled = soldOut;
        if (addLabel) {
          addLabel.textContent = !variant
            ? (Theme.strings.unavailable || 'Unavailable')
            : variant.available
              ? (Theme.strings.addToCart || 'Add to Cart')
              : (Theme.strings.soldOut || 'Sold Out');
        }
      }

      function update() {
        var options = selectedOptions();
        var variant = findVariant(options);

        markAvailability(options);
        setButtonState(variant);

        var labelHost = picker.querySelector('[data-selected-note]');
        if (labelHost) {
          labelHost.textContent = variant
            ? (labelHost.getAttribute('data-prefix') || '') + variant.title
            : (labelHost.getAttribute('data-empty') || '');
        }

        $$('[data-option-value][data-option-index]', picker).forEach(function (el) {
          var idx = Number(el.getAttribute('data-option-index'));
          el.textContent = options[idx] || '';
        });

        if (!variant) {
          if (idInput) idInput.value = '';
          return;
        }

        if (idInput) idInput.value = variant.id;

        if (priceHost && variant.price_html) priceHost.innerHTML = variant.price_html;
        if (skuHost) skuHost.textContent = variant.sku || '';

        if (gallery && gallery.__show && variant.featured_media_id) {
          gallery.__show(String(variant.featured_media_id));
        }

        if (updateUrl && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }

        document.dispatchEvent(new CustomEvent('rsc:variant:change', { detail: { variant: variant } }));
      }

      on(picker, 'change', function (e) {
        if (e.target && e.target.matches('input[type="radio"]')) update();
      });

      // Dropdown fallback for options with many values
      $$('select[data-option-index]', picker).forEach(function (select) {
        on(select, 'change', update);
      });

      update();
    });
  }

  /* ------------------------------------------------------------------------
     Standalone size picker used by the homepage feature block when no
     product is connected yet — purely visual, keeps the design honest.
     ------------------------------------------------------------------------ */
  function initDemoSizes(scope) {
    $$('[data-demo-sizes]', scope).forEach(function (group) {
      var note = document.querySelector('[data-demo-size-note][data-section="' + group.getAttribute('data-section') + '"]');
      on(group, 'change', function (e) {
        var input = e.target;
        if (!input.matches || !input.matches('input[type="radio"]')) return;
        if (note) {
          note.textContent = (note.getAttribute('data-prefix') || 'Size ') + input.value +
            (note.getAttribute('data-suffix') || '');
        }
        $$('[data-sticky-size]').forEach(function (el) {
          el.textContent = (el.getAttribute('data-prefix') || 'Size ') + input.value;
        });
      });
    });
  }

  function init(scope) {
    initGallery(scope);
    initVariantPicker(scope);
    initDemoSizes(scope);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target || document);
  });
})();
